import { buildLink, getUserDisplayName } from "./Utilities";
const domain = window.location.origin;

export const UNKNOWN = (
  shareId: any,
  name: string,
  partnerViewSession: any,
  platform: string,
) => {
  const EncodedURI = encodeURI(`${domain}/clip?clip=${shareId}`);
  const ShareEncodedURI = encodeURI(`${domain}/clip?clip=${shareId}`);
  const TiktokEncodedURI = encodeURI(`${domain}/clip?clip=${shareId}`);
  const YoutubeEncodedURI = encodeURI(`${domain}/clip?clip=${shareId}`);
  const DiscordEncodedURI = encodeURI(`${domain}/allstarbot`);
  const config = {
    uid: "",
    display: true,
    fullscreen: false,
    resconfig: "",
    knownUser: false,
    shareId: "",
    partner: {
      name: name,
    },
    remix: {
      show: true,
      link: buildLink({ url: `${domain}/remix/${shareId}` }),
    },
    share: {
      show: true,
      link: EncodedURI,
      share: ShareEncodedURI,
      tiktokShare: TiktokEncodedURI,
      youtubeShare: YoutubeEncodedURI,
      discordShare: DiscordEncodedURI,
    },
    edit: {
      show: true,
      link: buildLink({
        url: `${domain}/register`,
        game: partnerViewSession?.clip?.game,
        numClaimableClips: partnerViewSession?.claimableCount,
        username: getUserDisplayName(partnerViewSession),
        loggedInRedirect: `/clip/${shareId}?edit=true`,
        platform: platform,
      }),
    },
    download: {
      show: true,
      link: buildLink({
        url: `${domain}/register`,
        game: partnerViewSession?.clip?.game,
        numClaimableClips: partnerViewSession?.claimableCount,
        username: getUserDisplayName(partnerViewSession),
        loggedInRedirect: `/clip?clip=${shareId}`,
        platform: platform,
      }),
    },
    mobile: {
      show: true,
      link: buildLink({
        url: `${domain}/register`,
        game: partnerViewSession?.clip?.game,
        numClaimableClips: partnerViewSession?.claimableCount,
        username: getUserDisplayName(partnerViewSession),
        loggedInRedirect: `/clip?clip=${shareId}`,
        platform: platform,
      }),
    },
    quality: {
      show: true,
      mobileLink: buildLink({
        url: `${domain}/clip?clip=${shareId}`,
        platform: platform,
      }),
      remixLink: buildLink({ url: `${domain}/remix/${shareId}?remix=true` }),
    },
    replay: { show: true },
    centerText: {
      show: true,
      content: `partnerOverlay.centerText`,
    },
    button: {
      text: `partnerOverlay.signupButton`,
      link: buildLink({
        url: `${domain}/register`,
        game: partnerViewSession?.clip?.game,
        numClaimableClips: partnerViewSession?.claimableCount,
        username: getUserDisplayName(partnerViewSession),
        platform: platform,
      }),
      show: true,
    },
    attemptedAction: {
      discord: {
        actionPhrase: "partnerOverlay.discord.actionPhrase",
        button: "partnerOverlay.attemptedAction.share.button",
        link: buildLink({
          url: `${domain}/register`,
          game: partnerViewSession?.clip?.game,
          numClaimableClips: partnerViewSession?.claimableCount,
          username: getUserDisplayName(partnerViewSession),
          loggedInRedirect: `/clip?clip=${shareId}`,
          platform: platform,
        }),
      },
      tiktok: {
        actionPhrase: "partnerOverlay.tiktok.actionPhrase",
        button: "partnerOverlay.attemptedAction.share.button",
        link: buildLink({
          url: `${domain}/register`,
          game: partnerViewSession?.clip?.game,
          numClaimableClips: partnerViewSession?.claimableCount,
          username: getUserDisplayName(partnerViewSession),
          loggedInRedirect: `/clip?clip=${shareId}`,
          platform: platform,
        }),
      },
      youtube: {
        actionPhrase: "partnerOverlay.youtube.actionPhrase",
        button: "partnerOverlay.attemptedAction.share.button",
        link: buildLink({
          url: `${domain}/register`,
          game: partnerViewSession?.clip?.game,
          numClaimableClips: partnerViewSession?.claimableCount,
          username: getUserDisplayName(partnerViewSession),
          loggedInRedirect: `/clip?clip=${shareId}`,
          platform: platform,
        }),
      },
      download: {
        actionPhrase: "partnerOverlay.download.actionPhrase",
        button: "partnerOverlay.download.button",
        link: buildLink({
          url: `${domain}/register`,
          game: partnerViewSession?.clip?.game,
          numClaimableClips: partnerViewSession?.claimableCount,
          username: getUserDisplayName(partnerViewSession),
          loggedInRedirect: `/clip?clip=${shareId}`,
          platform: platform,
        }),
      },
      mobile: {
        actionPhrase: "partnerOverlay.mobile.actionPhrase",
        button: "partnerOverlay.mobile.button",
        link: buildLink({
          url: `${domain}/register`,
          game: partnerViewSession?.clip?.game,
          numClaimableClips: partnerViewSession?.claimableCount,
          username: getUserDisplayName(partnerViewSession),
          loggedInRedirect: `/clip?clip=${shareId}`,
          platform: platform,
        }),
      },
      addfx: {
        actionPhrase: "partnerOverlay.addfx.actionPhrase",
        button: "partnerOverlay.addfx.button",
        link: buildLink({
          url: `${domain}/register`,
          game: partnerViewSession?.clip?.game,
          numClaimableClips: partnerViewSession?.claimableCount,
          username: getUserDisplayName(partnerViewSession),
          loggedInRedirect: `/remix/${shareId}`,
          platform: platform,
        }),
      },
      editTitle: {
        actionPhrase: "partnerOverlay.editTitle.actionPhrase",
        button: "partnerOverlay.editTitleNMC.button",
        link: buildLink({
          url: `${domain}/register`,
          game: partnerViewSession?.clip?.game,
          numClaimableClips: partnerViewSession?.claimableCount,
          username: getUserDisplayName(partnerViewSession),
          loggedInRedirect: `/clip?clip=${shareId}`,
          platform: platform,
        }),
      },
      adjustQuality: {
        actionPhrase: "partnerOverlay.adjustQuality.actionPhrase",
        button: "partnerOverlay.adjustQuality.button",
        link: buildLink({
          url: `${domain}/register`,
          game: partnerViewSession?.clip?.game,
          numClaimableClips: partnerViewSession?.claimableCount,
          username: getUserDisplayName(partnerViewSession),
          loggedInRedirect: `/remix/${shareId}`,
          platform: platform,
        }),
      },
    },
  };
  return config;
};

export const KNOWN = (
  shareId: string,
  name: string,
  partnerViewSession: any,
) => {
  const EncodedURI = encodeURI(`${domain}/clip?clip=${shareId}`);
  const ShareEncodedURI = encodeURI(`${domain}/clip?clip=${shareId}`);
  const TiktokEncodedURI = encodeURI(`${domain}/clip?clip=${shareId}`);
  const YoutubeEncodedURI = encodeURI(`${domain}/clip?clip=${shareId}`);
  const DiscordEncodedURI = encodeURI(`${domain}/allstarbot`);

  let config = {
    uid: "",
    display: true,
    fullscreen: false,
    resconfig: "",
    knownUser: true,
    shareId: "",
    partner: {
      name: name,
    },
    remix: {
      show: true,
      link: buildLink({ url: `${domain}/remix/${shareId}` }),
    },
    share: {
      show: true,
      link: EncodedURI,
      share: ShareEncodedURI,
      tiktokShare: TiktokEncodedURI,
      youtubeShare: YoutubeEncodedURI,
      discordShare: DiscordEncodedURI,
    },
    edit: {
      show: true,
      link: buildLink({ url: `${domain}/clip/${shareId}?edit=true` }),
    },
    download: {
      show: true,
      link: buildLink({ url: `${domain}/clip?clip=${shareId}` }),
    },
    mobile: {
      show: true,
      link: buildLink({ url: `${domain}/clip?clip=${shareId}` }),
    },
    quality: {
      show: true,

      mobileLink: buildLink({
        url: `${domain}/clip?clip=${shareId}`,
      }),
      remixLink: buildLink({ url: `${domain}/remix/${shareId}` }),
    },
    replay: { show: true },
    centerText: {
      show: true,
      content: `partnerOverlay.centerText`,
    },
    button: {
      text: `partnerOverlay.signupButton`,
      link: buildLink({
        url: `${domain}/register`,
        game: partnerViewSession?.clip?.game,
        numClaimableClips: partnerViewSession?.claimableCount,
        username: getUserDisplayName(partnerViewSession),
      }),
      show: true,
    },
    attemptedAction: {
      discord: {
        actionPhrase: "partnerOverlay.discord.actionPhrase",
        button: "partnerOverlay.attemptedAction.share.button",
      },
      tiktok: {
        actionPhrase: "partnerOverlay.tiktok.actionPhrase",
        button: "partnerOverlay.attemptedAction.share.button",
      },
      youtube: {
        actionPhrase: "partnerOverlay.youtube.actionPhrase",
        button: "partnerOverlay.attemptedAction.share.button",
      },
      download: {
        actionPhrase: "partnerOverlay.download.actionPhrase",
        button: "partnerOverlay.download.button",
      },
      mobile: {
        actionPhrase: "partnerOverlay.mobile.actionPhrase",
        button: "partnerOverlay.mobile.button",
      },
      addfx: {
        actionPhrase: "partnerOverlay.addfx.actionPhrase",
        button: "partnerOverlay.addfx.button",
      },
      editTitle: {
        actionPhrase: "partnerOverlay.editTitle.actionPhrase",
        button: "partnerOverlay.editTitleNMC.button",
      },
    },
  };
  return config;
};

export const UNKNOWN_NMC = (
  shareId: any,
  name: string,
  partnerViewSession: any,
  platform: string,
) => {
  const EncodedURI = encodeURI(`${domain}/clip?clip=${shareId}`);
  const ShareEncodedURI = encodeURI(`${domain}/clip?clip=${shareId}`);

  const TiktokEncodedURI = encodeURI(`${domain}/clip?clip=${shareId}`);
  const YoutubeEncodedURI = encodeURI(`${domain}/clip?clip=${shareId}`);
  const DiscordEncodedURI = encodeURI(`${domain}/allstarbot`);

  let config = {
    uid: "",
    fullscreen: false,
    display: true,
    resconfig: "",
    knownUser: false,
    shareId: "",
    partner: {
      name: name,
    },
    remix: {
      show: true,
      link: buildLink({
        url: `${domain}/register`,
        game: partnerViewSession?.clip?.game,
        numClaimableClips: partnerViewSession?.claimableCount,
        username: getUserDisplayName(partnerViewSession),
        loggedInRedirect: `/remix/${shareId}`,
        platform: platform,
      }),
    },
    share: {
      show: true,
      link: EncodedURI,
      share: ShareEncodedURI,
      tiktokShare: TiktokEncodedURI,
      youtubeShare: YoutubeEncodedURI,
      discordShare: DiscordEncodedURI,
    },
    edit: {
      show: true,
      link: buildLink({
        url: `${domain}/register`,
        game: partnerViewSession?.clip?.game,
        numClaimableClips: partnerViewSession?.claimableCount,
        username: getUserDisplayName(partnerViewSession),
        loggedInRedirect: `/clip/${shareId}?edit=true`,
        platform: platform,
      }),
    },
    download: {
      show: true,
      link: buildLink({
        url: `${domain}/register`,
        game: partnerViewSession?.clip?.game,
        numClaimableClips: partnerViewSession?.claimableCount,
        username: getUserDisplayName(partnerViewSession),
        loggedInRedirect: `/clip?clip=${shareId}`,
        platform: platform,
      }),
    },
    mobile: {
      show: true,
      link: buildLink({
        url: `${domain}/register`,
        game: partnerViewSession?.clip?.game,
        numClaimableClips: partnerViewSession?.claimableCount,
        username: getUserDisplayName(partnerViewSession),
        loggedInRedirect: `/clip?clip=${shareId}`,
        platform: platform,
      }),
    },
    quality: {
      show: true,
      mobileLink: buildLink({
        url: `${domain}/clip?clip=${shareId}`,
        platform: platform,
      }),
      remixLink: buildLink({
        url: `${domain}/remix/${shareId}?remix=true`,
        platform: platform,
      }),
    },
    replay: { show: true },
    centerText: {
      show: true,
      content: `partnerOverlay.centerText`,
    },
    button: {
      text: `partnerOverlay.signupButton`,
      link: buildLink({
        url: `${domain}/register`,
        game: partnerViewSession?.clip?.game,
        numClaimableClips: partnerViewSession?.claimableCount,
        username: getUserDisplayName(partnerViewSession),
        platform: platform,
      }),
      show: true,
    },
    attemptedAction: {
      discord: {
        actionPhrase: "partnerOverlay.discord.actionPhrase",
        button: "partnerOverlay.signupButton",
        link: buildLink({
          url: `${domain}/register`,
          game: partnerViewSession?.clip?.game,
          numClaimableClips: partnerViewSession?.claimableCount,
          username: getUserDisplayName(partnerViewSession),
          loggedInRedirect: `/clip?clip=${shareId}`,
          platform: platform,
        }),
      },
      tiktok: {
        actionPhrase: "partnerOverlay.tiktok.actionPhrase",
        button: "partnerOverlay.signupButton",
        link: buildLink({
          url: `${domain}/register`,
          game: partnerViewSession?.clip?.game,
          numClaimableClips: partnerViewSession?.claimableCount,
          platform: platform,
          loggedInRedirect: `/clip?clip=${shareId}`,
        }),
      },
      youtube: {
        actionPhrase: "partnerOverlay.youtube.actionPhrase",
        button: "partnerOverlay.signupButton",
        link: buildLink({
          url: `${domain}/register`,
          game: partnerViewSession?.clip?.game,
          numClaimableClips: partnerViewSession?.claimableCount,
          loggedInRedirect: `/clip?clip=${shareId}`,
          platform: platform,
        }),
      },
      download: {
        actionPhrase: "partnerOverlay.download.actionPhrase",
        button: "partnerOverlay.signupButton",
        link: buildLink({
          url: `${domain}/register`,
          game: partnerViewSession?.clip?.game,
          numClaimableClips: partnerViewSession?.claimableCount,
          loggedInRedirect: `/clip?clip=${shareId}`,
          platform: platform,
        }),
      },
      mobile: {
        actionPhrase: "partnerOverlay.mobile.actionPhrase",
        button: "partnerOverlay.signupButton",
        link: buildLink({
          url: `${domain}/register`,
          game: partnerViewSession?.clip?.game,
          numClaimableClips: partnerViewSession?.claimableCount,
          loggedInRedirect: `/clip?clip=${shareId}`,
          platform: platform,
        }),
      },
      addfx: {
        actionPhrase: "partnerOverlay.addfx.actionPhrase",
        button: "partnerOverlay.signupButton",
        link: buildLink({
          url: `${domain}/register`,
          game: partnerViewSession?.clip?.game,
          numClaimableClips: partnerViewSession?.claimableCount,
          loggedInRedirect: `/remix/${shareId}`,
          platform: platform,
        }),
      },
      editTitle: {
        actionPhrase: "partnerOverlay.editTitle.actionPhrase",
        button: "partnerOverlay.signupButton",
        link: buildLink({
          url: `${domain}/register`,
          game: partnerViewSession?.clip?.game,
          numClaimableClips: partnerViewSession?.claimableCount,
          loggedInRedirect: `/clip?clip=${shareId}`,
          platform: platform,
        }),
      },
      adjustQuality: {
        actionPhrase: "partnerOverlay.adjustQuality.actionPhrase",
        button: "partnerOverlay.signupButton",
        link: buildLink({
          url: `${domain}/register`,
          game: partnerViewSession?.clip?.game,
          numClaimableClips: partnerViewSession?.claimableCount,
          loggedInRedirect: `/remix/${shareId}`,
          platform: platform,
        }),
      },
    },
  };
  return config;
};
